<template>
	<div class="allBox">
		<div class="treeMap_echarts" id="treeMap_echarts"></div>
		<div class="detailsList">
			<div
				class="detailsContent"
				v-for="(item, index) in detailsList"
				:key="index"
			>
				<a
					class="span1"
					:href="
						'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
							item.docid +
							'&leafid=' +
							item.leafid
					"
					target="_blank"
					:title="item.title"
					>{{ item.title }}</a
				>
				<span class="span2">{{ item.deliveddate.slice(0, 10) }}</span>
			</div>
		</div>
	</div>
</template>

<script>
import api from '@/../static/common/api/api.js';
import $ from 'jquery';
export default {
	name: '',
	props: ['echartsData', 'currentYear'],
	data() {
		return {
			detailsList: [], // 接口返回的数据
			treeList: [],
			currentYearNow: this.currentYear,
			_isMounted: false,
			timer: null,
		};
	},
	watch: {
		currentYear: {
			immediate: true,
			handler(to) {
				if (!this._isMounted) return; // 防止初始化时提前跑
				this.currentYearNow = to;
				this.$nextTick(() => {
					this.getEcharts(to);
				});
			},
		},
	},
	mounted() {
		this._isMounted = true; // 标记已挂载
		this.getEcharts(this.currentYearNow);
	},
	methods: {
		getEcharts(currentYearNow) {
			let _this = this;
			$.ajax({
				url: `https://www.drcnet.com.cn/reportapi/CommonController/common/docCountByTagAndYear?uid=A62303&year=${currentYearNow}&docIndexTypeId=90`,
				type: 'get',
				dataType: 'json',
				success: function(data) {
					if (data.data) {
						_this.treeList = data.data;
						_this.fetchDetails(
							data.data[0].name,
							_this.currentYearNow
						);

						// 确保有 DOM 再初始化图表
						var chartDom = document.getElementById(
							'treeMap_echarts'
						);
						var myChart = _this.$echarts.init(chartDom);

						let option = {
							color: [
								'#afd860',
								'#7bc96f',
								'#2ca61f',
								'#43aa4e',
								'#63b265',
								'#1f9f48',
								'#08933b',
								'#307945',
							],
							tooltip: {},
							series: [
								{
									type: 'treemap',
									roam: false,
									nodeClick: false,
									top: 0,
									left: 0,
									right: 0,
									bottom: 0,
									breadcrumb: { show: false },
									label: {
										overflow: 'break',
										fontSize: 16,
										formatter: function(params) {
											return params.name;
										},
									},
									data: _this.treeList, // 用接口数据
								},
							],
						};

						myChart.setOption(option);

						// 鼠标悬浮事件
						// myChart.on('mouseover', (param) => {
						// 	clearTimeout(_this.timer); // 先清掉
						// 	_this.timer = setTimeout(() => {
						// 		if (param.data) {
						// 			_this.fetchDetails(
						// 				param.data.name,
						// 				_this.currentYearNow
						// 			);
						// 		}
						// 	}, 200); // 延迟200ms再触发，防止抖动
						// });
						myChart.on('click', function(param) {
							// const url = `#/column?id=248&name=五周年专题&uid=A62303&showType=1-4&tag=${param.name}`;
							// window.open(url, '_blank'); // _blank 表示新开标签页
							_this.fetchDetails(
								param.data.name,
								_this.currentYearNow
							);
						});
					}
				},
				error: function(xhr, status, error) {
					console.error('请求失败:', status, error);
				},
			});
		},

		// 模拟接口请求
		async fetchDetails(name, currentYearNow) {
			// console.log(currentYearNow, 'currentYearNow');

			// 这里你替换成真实接口
			// let res = await axios.get(`/api/details?uid=${uid}`);
			// this.detailsList = res.data;
			let param = {
				uid: 'A62303',
				startDate: currentYearNow + '-1-1',
				endDate: currentYearNow + '-12-31',
				isDefaltYear: '0',
				dateType: '2',
				pagesize: 6,
				curpage: 1,
				keyword: name,
			};
			api.getarticleList(param).then((res) => {
				this.detailsList = res.data.rows;
				console.log(res);
			});
		},
	},
};
</script>

<style lang="less" scoped>
.allBox {
	display: flex;
	justify-content: space-between;
}
.treeMap_echarts {
	width: 624px;
	height: 257px;
}
.detailsList {
	width: 48%;
	display: flex;
	padding: 16px 0;
	flex-direction: column;
	justify-content: space-around;
	.span1 {
		width: 84%;
		font-size: 15px;
		color: #333333;
		display: inline-block;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	.span2 {
		width: 15%;
		font-size: 15px;
		color: #666666;
		display: inline-block;
		text-align: right;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	.detailsContent {
		display: flex;
		align-items: center;
		line-height: 36px;
	}
	.detailsContent:before {
		content: ' ';
		display: inline-block;
		border-radius: 50%;
		background: #333333;
		height: 4px;
		width: 5px;
		margin-right: 5px;
	}
}
</style>



// WEBPACK FOOTER //
// src/view/fiveth/components/treemap/index.vue